import { ChartPieIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import Link from '@/components/atoms/Link/Link';
import TileEmptyPage from '@/components/organisms/Tile/TileEmptyPage/TileEmptyPage';
import PageContentWrapper from '@/components/templates/PageContentWrapper';
import { useAccount } from '@/hooks/useAccount';

const DisabledAnalytics = () => {
  const navigate = useNavigate();
  const { slug, accountRole } = useAccount();
  const { t } = useTranslation();
  const body =
    accountRole !== 'owner' ? (
      t('permissions.contact_admin')
    ) : (
      <>
        <p>{t('analytics.activate')}</p>
        <p>
          <Link
            onClick={() => {
              navigate(`/${slug}/account/data-privacy`);
            }}
          >
            {t('profile.account_settings')}
          </Link>
        </p>
      </>
    );

  return (
    <PageContentWrapper>
      <TileEmptyPage
        title={t('analytics.unavailable')}
        notClickable
        isFullHeight
        body={body}
        icon={<ChartPieIcon size={128} className="text-muted-foreground" />}
      />
    </PageContentWrapper>
  );
};

export default DisabledAnalytics;
